export default __webpack_public_path__ + "static/media/M1A_8.0fb4b339.png";